module.exports = __webpack_public_path__ + "static/media/project-image-5.91867b96.jpg";